'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _consts = require('../consts.js');

var _ProviderIntent = require('../components/ProviderIntent.js');

var _ProviderIntent2 = _interopRequireDefault(_ProviderIntent);

var _cartApi = require('../../cartApi.js');

var _cartApi2 = _interopRequireDefault(_cartApi);

var _providerEvents = require('wix-art-store-3rd-party/dist/src/sdk/providerEvents');

var _providerEvents2 = _interopRequireDefault(_providerEvents);

var _mobileViewTypes = require('wix-art-store-3rd-party/dist/src/sdk/mobileViewTypes');

var _mobileViewTypes2 = _interopRequireDefault(_mobileViewTypes);

var _storeApi = require('../../storeApi');

var _storeApi2 = _interopRequireDefault(_storeApi);

var _utils = require('../../utils/utils');

var _IntentCartOperations = require('../components/IntentCartOperations');

var _IntentCartOperations2 = _interopRequireDefault(_IntentCartOperations);

var _WixSDKProviderApi = require('../components/WixSDKProviderApi');

var _WixSDKProviderApi2 = _interopRequireDefault(_WixSDKProviderApi);

var _WixSdkWrapper = require('photography-client-lib/dist/src/sdk/WixSdkWrapper');

var _WixSdkWrapper2 = _interopRequireDefault(_WixSdkWrapper);

var _windowWrapper = require('photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types, no-case-declarations */
var FullScreenShop = function (_Component) {
  (0, _inherits3.default)(FullScreenShop, _Component);

  function FullScreenShop(props) {
    (0, _classCallCheck3.default)(this, FullScreenShop);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullScreenShop.__proto__ || (0, _getPrototypeOf2.default)(FullScreenShop)).call(this, props));

    _this.state = {
      height: 0
    };

    // The cart icon may not be there.. so we need to ensure it's created in the fullscreen
    _cartApi2.default.createCartForm();
    return _this;
  }

  (0, _createClass3.default)(FullScreenShop, [{
    key: 'postShopRequest',
    value: function postShopRequest(type, data) {
      if (this.shopIntent) {
        this.shopIntent.postMessage(type, data);
      }
    }
  }, {
    key: 'addToCartRequest',
    value: function addToCartRequest() {
      if (this.shopIntent) {
        this.shopIntent.postMessage(_providerEvents2.default.addToCartRequest, {});
      }
    }
  }, {
    key: 'sendItemData',
    value: function sendItemData(item) {
      if (item && item.getDataForShop) {
        this.shopIntent.postMessage(_providerEvents2.default.itemChanged, item.getDataForShop());
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      var item = nextProps.item;
      if (item) {
        if (this.shopIntent) {
          if (this.props.item && this.props.item.id !== item.id) {
            this.sendItemData(item);
          }
        }
      }
    }
  }, {
    key: 'messageReceived',
    value: function messageReceived(type, payload, resolve, reject, providerId) {
      var _props = this.props,
          styleId = _props.styleId,
          pageId = _props.pageId,
          additionalParams = _props.additionalParams;
      var galleryId = additionalParams.galleryId,
          itemUrl = additionalParams.itemUrl,
          isDemo = additionalParams.isDemo;

      isDemo = !!isDemo;
      switch (type) {
        case _providerEvents2.default.sdkReady:
          this.sendItemData(this.props.item);
          console.time('Provider items load time');
          break;
        case _providerEvents2.default.addToCart:
          var uuid = payload.uuid,
              quantity = payload.quantity,
              metadata = payload.metadata;

          _cartApi2.default.addToCart(uuid, itemUrl, galleryId, providerId, quantity, isDemo, metadata, styleId).then(function (newItem) {
            _cartApi2.default.showCart();
            _cartApi2.default.updateItemsValidation([newItem]);
            resolve();
          });
          break;
        case _providerEvents2.default.setHeight:
          this.setState(payload);
          break;
        case _providerEvents2.default.close:
          _utils.utils.isMobile() ? this.props.actions.toggleMobileShopFrame() : null;
          break;
        case _providerEvents2.default.setMobileProductData:
          this.props.onSetMobileData(payload.type, payload.data);
          console.timeEnd('Provider items load time');
          break;
        case _providerEvents2.default.setDefaultPrice:
          var priceData = payload;
          this.props.onSetMobileData(_mobileViewTypes2.default.singleProduct, priceData);
          break;
        case _providerEvents2.default.openModal:
          var name = payload.name,
              options = payload.options;

          _storeApi2.default.openProviderModal(name, this.props.connectedProviders, options, { galleryId: galleryId, itemUrl: itemUrl, isDemo: isDemo, styleId: styleId, pageId: pageId }).then(resolve).catch(reject);
          break;
        default:
          (0, _IntentCartOperations2.default)(type, payload, resolve, reject, providerId);
          break;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var height = this.state.height;
      var connectedProviders = this.props.connectedProviders;


      var wixSdk = _WixSdkWrapper2.default;
      try {
        if (_utils.utils.isInSettings()) {
          wixSdk = _windowWrapper2.default.parent.Wix;
        }
      } catch (error) {}
      var renderComponent = connectedProviders ? _react2.default.createElement(
        'div',
        { className: 'full-screen-shop', style: { height: height + 'px' } },
        _react2.default.createElement(_ProviderIntent2.default, (0, _extends3.default)({
          api: new _WixSDKProviderApi2.default(wixSdk),
          ref: function ref(r) {
            return _this2.shopIntent = r;
          },
          intent: _consts.providerIntents.shop,
          tabIndex: _utils.utils.getTabIndex('fullscreenProvider'),
          onMessageReceived: function onMessageReceived(type, payload, resolve, reject, providerId) {
            _this2.messageReceived(type, payload, resolve, reject, providerId);
          }
        }, this.props, {
          connectedProviders: connectedProviders
        }))
      ) : null;
      return renderComponent;
    }
  }]);
  return FullScreenShop;
}(_react.Component);
/* eslint-enable react/prop-types, no-case-declarations */

exports.default = FullScreenShop;